export default __webpack_public_path__ + "static/media/uploader-oneTouchUltra2-problem-2.3fe5a4ed.png";